import { Empresa } from "../../models/usuario/empresa.model";

export class EmpresaGrupoStruct {
    idEmpresaGrupo: number | null;
    nomeEmpresaGrupo: string;
    empresaPrincipal: Empresa | null;
}